import { useTranslation } from 'i18n';
import { ConfirmationIconButton, IconButton, Paper, Stack, Typography } from 'ui';
import { Close, Delete, DriveFileMove } from 'ui/icons';

type Props = {
  handleClose: () => void;
  handleDelete?: () => void;
  handleMove?: () => void;
  selected: number;
  actionPending?: boolean;
};

export const ActionBar = ({ selected, handleClose, handleDelete, handleMove, actionPending }: Props) => {
  const { t } = useTranslation('features');
  const { t: tCommon } = useTranslation('common');

  return (
    <Paper elevation={2} sx={{ borderRadius: 4 }}>
      <Stack
        direction="row"
        sx={{
          gap: 1,
          py: 1,
          px: 2,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <IconButton size="small" disabled={actionPending} onClick={handleClose}>
          <Close />
        </IconButton>
        <Typography>{t('evidence.actionBar.selectedCount', { values: { selected } })}</Typography>

        <Stack
          direction="row"
          sx={{
            gap: 1,
          }}
        >
          {handleDelete ? (
            <ConfirmationIconButton
              size="small"
              disabled={!selected || actionPending}
              onConfirm={handleDelete}
              message={t('evidence.actionBar.deletePrompt')}
              title={t('evidence.actionBar.deleteTitle', { values: { evidence: tCommon('domains.evidence') } })}
              data-testid="delete-evidence-button"
            >
              <Delete />
            </ConfirmationIconButton>
          ) : null}
          {handleMove ? (
            <IconButton size="small" disabled={!selected || actionPending} onClick={handleMove}>
              <DriveFileMove />
            </IconButton>
          ) : null}
        </Stack>
      </Stack>
    </Paper>
  );
};
